import React from "react";
const icon = (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M418.4 157.9C453.7 149.6 480 117.9 480 80C480 35.8 444.2 0 400 0C356.6 0 321.3 34.5 320 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128C35.8 128 0 163.8 0 208C0 252.2 35.8 288 80 288C92.2 288 103.8 285.3 114.1 280.4L259.7 407.8C257.3 415.4 256 423.6 256 432C256 476.2 291.8 512 336 512C380.2 512 416 476.2 416 432C416 404.3 402 379.9 380.6 365.6L418.4 157.9ZM156.3 232.2C158.5 225.3 159.8 218 160 210.5L343.8 137C347.4 140.5 351.2 143.7 355.4 146.5L317.6 354.1C312.1 355.4 306.8 357.2 301.8 359.6L156.3 232.2Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
